import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    title: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.title',
        defaultMessage: 'Subskrypcje',
    },
    activeSubscription: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.activeSubscription',
        defaultMessage: 'Aktualny plan',
    },
    planName: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.planName',
        defaultMessage: 'Plan {name}',
    },
    active: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.active',
        defaultMessage: 'Aktywny',
    },
    validUntil: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.validUntil',
        defaultMessage: 'Ważna do',
    },
    nextPayment: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.nextPayment',
        defaultMessage: 'Najbliższa płatność',
    },
    cancel: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.cancel',
        defaultMessage: 'Wyłącz subskrypcję',
    },
    upgrade: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.upgrade',
        defaultMessage: 'Upgraduj',
    },
    paymentMethods: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.paymentMethods',
        defaultMessage: 'Metody płatności',
    },
    default: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.default',
        defaultMessage: 'Domyślna',
    },
    addPaymentMethod: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.addPaymentMethod',
        defaultMessage: 'Dodaj metodę',
    },
    setDefaultPaymentMethod: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.setDefaultPaymentMethod',
        defaultMessage: 'Ustaw jako domyślną',
    },
    availablePlans: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.availablePlans',
        defaultMessage: 'Dostępne plany subskrypcji',
    },
    choosePlan: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.choosePlan',
        defaultMessage: 'Wybierz plan',
    },

    editCardTitle: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.editCardTitle',
        defaultMessage: 'Edytuj kartę płatniczą',
    },
    cardNumber: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.cardNumber',
        defaultMessage: 'Numer karty',
    },
    cardHolder: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.cardHolder',
        defaultMessage: 'Imię i nazwisko',
    },
    expiryDate: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.expiryDate',
        defaultMessage: 'Data ważności',
    },
    cvv: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.cvv',
        defaultMessage: 'CVV',
    },
    save: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.save',
        defaultMessage: 'Zapisz',
    },
    cancelModal: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.cancelModal',
        defaultMessage: 'Anuluj',
    },
    expires: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.expires',
        defaultMessage: 'Wygasa',
    },
    month: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.month',
        defaultMessage: 'Miesiąc',
    },
    monthLower: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.monthLower',
        defaultMessage: 'miesiąc',
    },
    paymentMethod: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.paymentMethod',
        defaultMessage: 'Metoda płatności',
    },
    planIncludes: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.planIncludes',
        defaultMessage: 'W ramach planu:',
    },
    cancelRenewal: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.cancelRenewal',
        defaultMessage: 'Anuluj odnowienie',
    },
    lower: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.lower',
        defaultMessage: 'Przejdź na darmowy',
    },
    mostPopular: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.mostPopular',
        defaultMessage: 'Najczęściej wybierany',
    },
    current: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.current',
        defaultMessage: 'Aktualny',
    },
    reactivate: {
        id: 'src.Screens.Dashboard.Subscription.Subscription.reactivate',
        defaultMessage: 'Aktywuj ponownie',
    },
});
